import { Component, computed, inject, input } from '@angular/core'
import { rxResource } from '@angular/core/rxjs-interop'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { of } from 'rxjs'
import { PublicService } from 'src/app/public/services/public.service'

@Component({
    selector: 'sf-payment-cancel',
    imports: [FontAwesomeModule],
    templateUrl: './payment-cancel.component.html',
    styleUrl: './payment-cancel.component.scss',
})
export class PaymentErrorComponent {
    #publicService = inject(PublicService)

    companyId = input<number>()

    #companyResource = rxResource({
        request: () => this.companyId(),
        loader: ({ request }) => {
            if (!request) {
                return of(null)
            }
            return this.#publicService.getCompanyDetails(request)
        },
    })

    company = computed(() => this.#companyResource.value())
}
